import { render, staticRenderFns } from "./presentationProductMview.vue?vue&type=template&id=5120b3e3&"
import script from "./presentationProductMview.vue?vue&type=script&lang=js&"
export * from "./presentationProductMview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports